import styled, { keyframes } from 'styled-components';

const BLUE_COLOR = '#003087';

export const Container = styled.div`
	min-width: 20rem;
	max-width: 45rem;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	border-radius: 12px;
	padding: 2rem 1.5rem;
	background-color: #e6f3ff;
	border: 2px solid ${BLUE_COLOR};
	box-shadow: 0 2px 8px #002fbb14;

	@media (max-width: 576px) {
		min-width: 100%;
		padding: 20px 12px;
	}
`;

export const Title = styled.div`
	font-weight: 700;
	font-size: 1.3rem;
	color: ${BLUE_COLOR};

	@media (max-width: 576px) {
		font-size: 1.1rem;
	}
`;

const countUpAnimation = keyframes`
  0% { opacity: 0; transform: translateY(20px) scale(0.95); }
  80% { opacity: 1; transform: translateY(-4px) scale(1.05); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

export const HighlightValue = styled.span`
	display: block;
	font-weight: 700;
	font-size: 2.5rem;
	text-align: center;
	animation: ${countUpAnimation} 1.5s ease-out;
	color: #edab1e;

	@media (max-width: 576px) {
		font-size: 1.8rem;
	}
`;
